<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />
        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
            <userLeft :active="12" />
            <div class="box5">
                <div class="title">售后详情</div>
                <div style="width: 100%;height: 1px;background: #EDE9E9; margin: 20px 0"></div>
                <div v-for="(item, index) in list_goods" style="overflow: hidden;" :key="index">
                    <!-- <img :src="'/api/file/preview/'+ i.cover" style="width: 72px;height: 90px;float: left;" alt="">
            <div style="float: left;margin-left: 20px;width: 85%;margin: 10px 0">
                <div style="overflow: hidden;">
                  <a-row>
                    <a-col :span="8">
                      <div class="goods_title">订单编号：{{info.orderSn}}</div>
                    </a-col>
                    <a-col :span="8">
                      <div class="goods_title" style="text-align: right;color: #333; font-size: 14px;">售后申请时间：<span style="color: #2B9A34;">{{after_sale.applyAt}}</span></div>
                    </a-col>
                    <a-col :span="8">
                      <div class="goods_title" style="text-align: right;color: #333; font-size: 14px;cursor: pointer;" @click="toMessage">返回列表></div>
                    </a-col>
                  </a-row>

                </div>
                <div class="goods_title1">{{i.productName}}          CAS号：{{i.casNum}} </div>
                <div class="goods_title1" style="color: #666;">详细：【货号】{{i.skuSn}} 【品牌】{{i.brandName}} 【包装】{{i.packaging}} 【规格】{{i.specification}}</div>
            </div> -->
                    <img v-if="item.cover" :src="'/api/file/preview/' + item.cover" style="width: 72px; height: 90px; float: left;margin-top:5px" alt="" />
                    <img v-else src="../assets/pro-default-img@2x.png" style="width: 72px; height: 90px; float: left;margin-top:5px" alt="" />
                    <div style="float: left; margin: 0px 0 10px 20px">
                        <!-- <div class="goods_title">
              <div>
              </div>
            </div> -->
                        <div class="goods_title1" style=";margin-top:5px">
                            <span style="width:200px;display: inline-block;">{{ item.productName }} CAS号：{{ item.casNum }}</span>
                            <span style="width:180px;display: inline-block;margin-left:60px;color:#bbb;color: #2b9a34">退货数量：{{ item.afterSale.returnNum }}</span>
                            <span style="width:260px;display: inline-block;;color:#bbb;color: #2b9a34">退货原因：{{ item.afterSale.reason }}</span>
                            <span class="tijiao1" @click="updated(item, index)">查看</span>
                        </div>
                        <div class="goods_title1" style="color: #666;margin-top:20px">详细：【编号】{{ item.skuSn }} 【品牌】{{ item.brandName }} 【包装】{{ item.packaging }}【规格】{{ item.specification }}【数量】{{ item.quantity }}</div>
                    </div>
                </div>
                <div style="width: 100%;height: 1px; margin: 20px 0; border-bottom: 1px dashed #EDE9E9;"></div>
                <div>
                    <div style="font-size: 14px;font-weight: 400;color: #333333;margin:10px">
                        <span v-html="after_sale.description"></span>
                    </div>
                </div>
                <div style="font-size: 16px;">售后沟通记录</div>
                <div class="haha">
                    <div v-for="(i, index) in after_sale_log" class="item" :key="index">
                        <img v-if="i.avatar !== null" :src="i.avatar | imgStr" />
                        <div class="item-content">
                            <div style="overflow: hidden;">
                                <div style="font-size: 14px;font-weight: 400;color: #333333;float: left;">{{ i.userName }}</div>
                                <div style="float: right;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #666666;">{{ i.replyAt }}</div>
                            </div>
                            <div style="font-size: 14px;font-weight: 400;color: #000000;margin-top: 20px;">{{ i.content }}</div>
                        </div>
                    </div>
                </div>

                <div class="item">
                    <img v-if="avatar !== null" :src="avatar | imgStr" />
                    <textarea placeholder="请输入你要回复的内容" v-model="input"></textarea>
                    <div style="display: flex;justify-content: space-between; ">
                        <div class="tijiao" @click="submit">回复</div>
                        <div class="tijiao" style="font-size:14px" @click="wuliuxinxi">提交快递信息</div>
                    </div>
                </div>
            </div>
        </div>
        <a-modal title="物流信息填写" :width="450" :visible="visible" @ok="handleShipping" @cancel="handleCancel">
            <a-form>
                <a-form-item label="发货方式" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
                    <a-input v-model="shippingBean.shippingMethodName" placeholder="请输入" />
                </a-form-item>
                <a-form-item label="快递单号" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
                    <a-input v-model="shippingBean.shippingNo" placeholder="请输入" />
                </a-form-item>
                <a-form-item label="快递标记" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
                    <a-input v-model="shippingBean.shippingRemarks" placeholder="请输入" />
                </a-form-item>
            </a-form>
        </a-modal>
        <a-modal :visible="visible_shouhuo" :width="700" @cancel="visible_shouhuo = false">
            <!-- 请输入退货数量<a-input-number :min="0" type="number" style="width:100px" /> -->
            <a-row class="form-row" :gutter="24" style="margin-top:20px">
            <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                    <a-form-item label="商品规格：">
                        编号：{{ list.skuSn }} 品牌：{{ list.brandName }} 规格：{{ list.specification }}数量：{{ list.quantity }}
                    </a-form-item>
                    <a-form-item label="退货数量：">
                        <a-input-number :min="0" v-model="orderList.returnNum" :disabled="true" :max="list.quantity" type="number" style="width:70%" />
                    </a-form-item>
                    <a-form-item label="选择售后原因：">
                        <a-select v-model="orderList.reason" :disabled="true" style="width:70%">
                            <a-select-option value="质量问题">
                                质量问题
                            </a-select-option>
                            <a-select-option value="特殊需求">
                                特殊需求
                            </a-select-option>
                            <a-select-option value="使用问题">
                                使用问题
                            </a-select-option>
                            <a-select-option value="破损问题">
                                破损问题
                            </a-select-option>
                            <a-select-option value="包装问题">
                                包装问题
                            </a-select-option>
                            <a-select-option value="运输丢失">
                                运输丢失
                            </a-select-option>
                            <a-select-option value="数量短少">
                                数量短少
                            </a-select-option>
                            <a-select-option value="其他问题">
                                其他问题
                            </a-select-option>
                            <a-select-option value="仪器维修">
                                仪器维修
                            </a-select-option>
                            <a-select-option value="破损丢失">
                                破损丢失
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                <!-- <a-col :lg="24" :md="24" :sm="24">
              <a-form-item>
                <div class="goods_table_base_left1" >选择服务类型：</div>
                <a-select
                  v-model="orderList.type"
                  :disabled="true"
                 style="width:70%"
                >
                  <a-select-option value="REFUNDS_RETURNS">
                    我要退款（无需退货）没收到货，或与卖家协商同意不用退货只退款
                  </a-select-option>
                  <a-select-option value="ONLY_REFUNDS">
                    我要退货退款 已收到货，需要退还收到的货物
                  </a-select-option>
                  <a-select-option value="EXCHANGE_GOODS">
                    我要换货 已收到货，需要更换已收到的货物
                  </a-select-option>
                </a-select>
              </a-form-item>
          </a-col> -->
                    <a-form-item label="上传图片：">
                        <!-- <img src="" alt=""> -->
                        <div v-for="(item, index) in orderList.images" :key="index" style="float: left;margin-right:10px">
                            <img v-if="item" :src="`/api/file/preview/${item}`" style="width:80px;height: 80px;border:1px solid #ccc" />
                        </div>
                    </a-form-item>
                    <a-form-item label="问题描述：">
                        <a-input placeholder="请输入退货原因" v-model="orderList.description" :rows="2" style="width:70%" :disabled="true" />
                    </a-form-item>
            </a-form>
            </a-row>
        </a-modal>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
import E from 'wangeditor';
export default {
    name: 'integral',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {
            order_id: '',
            type: 0,
            info: {},
            after_sale: {},
            after_sale_log: [],
            list_goods: [],
            avatar: '',
            input: '',
            list: {},
            visible: false,
            orderList: {},
            shippingBean: {
                shippingMethodName: '',
                shippingNo: '',
                shippingRemarks: ''
            },
            visible_shouhuo: false
        };
    },
    filters: {
        imgStr(value) {
            return value ? `/api/file/preview/${value}` : '';
        }
    },
    mounted() {
        const editor = new E('#editorElem');
        // 上传
        // editor.customConfig.customUploadImg = (files, insert) => {
        //     const formData = new FormData();
        //     formData.append("file", files[0]);
        //     formData.append("path", "files/ne-icev3-dashboard/content/content/");
        //     axios.post("/public/index.php/test", formData).then(res => {
        //         const result = res.data;
        //         console.log(result);
        //         const data = result.data;
        //         insert(data);
        //     });
        // };
        // 赋值
        editor.config.onchange = res => {
            this.form.complaint = res;
        };
        editor.create();
    },
    created() {
        let userinfo = window.localStorage.user_info;
        this.order_id = this.$route.query.uuid;
        this.getInfo();
        if (userinfo) {
            userinfo = JSON.parse(userinfo);
            this.avatar = userinfo.avatar;
        }
    },
    methods: {
        updated(e, i) {
            console.log(e);
            this.list = e;
            this.orderList = e.afterSale;
            this.visible_shouhuo = true;
            // this.index = i
        },
        wuliuxinxi() {
            this.visible = true;
        },
        handleShipping() {
            console.log(this.shippingBean.shippingMethodName, '------------');
            if (this.shippingBean.shippingMethodName == '' || this.shippingBean.shippingNo == '' || this.shippingBean.shippingRemarks == '') {
                this.$message.error('请填写物流信息');
                // this.visible = false
            } else {
                const input = '' + '发货方式：' + this.shippingBean.shippingMethodName + '发货方式：' + this.shippingBean.shippingNo + '快递标记：' + this.shippingBean.shippingRemarks;
                this.api.afterSaleReply(this.order_id, input).then(() => {
                    this.$message.success('提交成功');
                    this.shippingBean.shippingMethodName = '';
                    this.shippingBean.shippingNo = '';
                    this.shippingBean.shippingRemarks = '';
                    this.visible = false;
                    this.getInfo();
                });
            }
        },
        handleCancel() {
            this.visible = false;
        },
        toMessage() {
            this.$router.push('/message');
        },
        getInfo() {
            this.api.get_order_jindu(this.order_id).then(res => {
                console.log(res);
                if (res.ok) {
                    this.after_sale = res.data.afterSale;
                    this.after_sale_log = [...res.data.afterSaleLog];
                    console.log(this.after_sale_log);
                    this.list_goods = [...res.data.ordersItemList];
                    delete res.data.afterSale;
                    delete res.data.afterSaleLog;
                    delete res.data.ordersItemList;

                    this.info = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        submit() {
            if (!this.input) {
                this.$message.error('请输入回复消息内容');
            } else {
                this.api.afterSaleReply(this.order_id, this.input).then(() => {
                    this.$message.success('提交成功');
                    this.input = '';
                    this.getInfo();
                });
            }
        }
    }
};
</script>

<style scoped>
.haha {
    /* overflow-x:auto; */
    display: inline-block;
    width: 100%;
    height: 498px;
    overflow: auto;
}
.item {
    padding: 0 20px;
    overflow: hidden;
    border-bottom: 1px dashed #ede9e9;
}
div > .item:last-child {
    border-bottom: none;
}
.item > img {
    float: left;
    margin-top: 20px;
    width: 24px;
    height: 24px;
    background: #e0e0e0;
    border-radius: 50%;
}
.item-content {
    margin-left: 40px;
    padding: 20px 0;
}

textarea {
    display: block;
    margin: 20px 0 20px 40px;
    padding: 10px;
    width: 837px;
    height: 74px;
    border: 1px solid #ede9e9;
}
.tijiao1 {
    display: inline-block;
    width: 100px;
    height: 32px;
    border: 1px solid #2b9a34;
    text-align: center;
    line-height: 32px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    /* margin-left: 40px;
  margin-top: 40px;
  margin-bottom: 40px; */
    cursor: pointer;
}
.goods_table_base_left1 {
    width: 150px;
    text-align: left;
    display: inline-block;
    /* text-align: center; */
}
textarea:focus {
    outline: none;
}

.xuanzhong {
    border: 1px solid #2b9a34;
}
.goods_title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.goods_title1 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 10px;
}

.title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}

.box5 {
    width: 80%;
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 2%;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}
.type_title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 10px;
    margin-left: 20px;
}

.type_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999;
    margin-top: 10px;
    margin-left: 20px;
}
.rich_text_box {
    width: 90%;
    float: left;
    margin-top: 25px;
    margin-left: 2%;
    height: 400px;
    overflow: hidden;
}

.tijiao {
    width: 100px;
    height: 40px;
    border: 1px solid #2b9a34;
    text-align: center;
    line-height: 40px;

    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    margin-left: 40px;
    margin-bottom: 40px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/refund_details.vue